import { combineReducers } from '@reduxjs/toolkit';

import emailTemplatesReducer from './emailTemplatesSlice';
import importUsersReducer from './importUsers';
import leadFieldsReducer from './leadFieldsSlice';
import leadFormsReducer from './leadFormsSlice';
import leadStagesReducer from './leadStagesSlice';
import permissionTemplateFormReducer from './permissionTemplateFormSlice';
import permissionTemplatesReducer from './permissionTemplatesSlice';
import requestsSliceReducer from './requestsSlice';
import selectedKeyReducer from './settingsSlice';
import telephonyNumbersReducer from './telephonyNumbersSlice';
import usersReducer from './usersSlice';

export const settingsReducers = combineReducers({
  selectedKey: selectedKeyReducer,
  requests: requestsSliceReducer,
  permissionTemplates: permissionTemplatesReducer,
  permissionTemplateForm: permissionTemplateFormReducer,
  users: usersReducer,
  leadFields: leadFieldsReducer,
  leadForms: leadFormsReducer,
  importUsers: importUsersReducer,
  leadStages: leadStagesReducer,
  emailTemplates: emailTemplatesReducer,
  telephonyNumbers: telephonyNumbersReducer,
});
